import { baseApi } from '../baseApi';

import { TransactionPaymentReason } from './TransactionPaymentReason';

const transactionPaymentReasonSlice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['TransactionPaymentReasons'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getTransactionPaymentReasons: builder.query<TransactionPaymentReason[], void>({
        keepUnusedDataFor: 60,
        query: () => ({
          url: '/TransactionPaymentReasons',
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'TransactionPaymentReasons' as const,
                  id,
                })),
                { type: 'TransactionPaymentReasons', id: 'LIST' },
              ]
            : [{ type: 'TransactionPaymentReasons', id: 'LIST' }],
      }),
    }),
  });

export const { useGetTransactionPaymentReasonsQuery } = transactionPaymentReasonSlice;
